import styled, { keyframes } from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.verticalSpacingM};
  width: 48%;
`
export const ThumbnailWrapper = styled.div`
  position: relative;
  width: 100%;
  border-radius: ${({ theme }) => theme.radius.md};

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`
const FadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

export const Thumbnail = styled.div<{ image1x: string; image2x: string; image3x: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: ${({ theme }) => theme.radius.md};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  animation: ${FadeIn} 0.6s forwards;
  background-image: -webkit-image-set(
    url(${({ image1x }) => `'${image1x}'`}) 1x,
    url(${({ image2x }) => `'${image2x}'`}) 2x,
    url(${({ image3x }) => `'${image3x}'`}) 3x
  );
  background-image: image-set(
    url(${({ image1x }) => `'${image1x}'`}) 1x,
    url(${({ image2x }) => `'${image2x}'`}) 2x,
    url(${({ image3x }) => `'${image3x}'`}) 3x
  );
`

export const ProductLabel = styled.div`
  padding: ${({ theme }) => `${theme.spacing.verticalSpacingXXS} ${theme.spacing.horizontalSpacingXS}`};
  border-radius: 96px;
  z-index: 99;
  position: absolute;
  top: ${({ theme }) => theme.spacing.verticalSpacingM};
  left: ${({ theme }) => theme.spacing.horizontalSpacingM};
  background: ${({ theme }) => theme.colors.textAndBackgroundLightGrey};
`

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${({ theme }) => theme.spacing.verticalSpacingXS};
  gap: ${({ theme }) => theme.spacing.verticalSpacingXS};
`
